
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33994',
  depVersions: {
  "documents-public-ui": "static-1.33994",
  "client-types": "static-1.446",
  "documents-lib": "static-1.33999",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1936",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4841",
  "highcharts": "static-8.99",
  "hs-promise-utils": "static-1.5402",
  "hs-test-utils": "static-1.7814",
  "hub-http": "static-1.6029",
  "hubspot-dlb": "static-2.1806",
  "HubStyleTokens": "static-2.11241",
  "I18n": "static-7.1572",
  "jasmine-immutable": "static-1.2827",
  "jasmine-runner": "static-1.6281",
  "lodash": "static-1.3",
  "quartz": "static-1.6747",
  "react": "static-7.179",
  "react-dlb": "static-1.72",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.67",
  "react-rhumb": "static-1.16459",
  "reporting-data": "static-1.66564",
  "reporting-testing-lib": "static-1.8497",
  "reporting-visualizations": "static-1.58640",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4574",
  "webpack-env": "static-1.54",
  "atom": "static-1.4878",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2295",
  "classnames": "static-2.10",
  "cssUtils": "static-1.734",
  "customer-data-filters-ui": "static-1.38939",
  "customer-data-objects": "static-1.7458",
  "customer-data-property-utils": "static-1.7886",
  "data-fetching-client": "static-1.9487",
  "enviro": "static-4.405",
  "FireAlarmUi": "static-1.4337",
  "flux-actions": "static-1.310",
  "FormsCommonComponents": "static-1.85309",
  "FormUrlGenerator": "static-2.4538",
  "foundations-components": "static-1.7540",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3957",
  "HubStyle": "static-2.11549",
  "icons": "static-2.623",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6969",
  "metrics-js": "static-1.9436",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.367",
  "property-description-translator": "static-1.3667",
  "property-translator": "static-1.5221",
  "quartz-config": "static-1.525",
  "quartz-core": "static-1.5966",
  "quick-fetch": "static-1.3743",
  "raven": "static-3.5725",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5181",
  "react-virtualized": "static-2.94",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7969",
  "reference-resolvers-lite": "static-1.7903",
  "report-customization-components": "static-1.12529",
  "reporting-enablement": "static-1.22106",
  "reporting-reports": "static-1.66242",
  "reporting-snowflake": "static-1.55182",
  "reporting-ui-components": "static-2.63835",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4443",
  "sales-content-partitioning": "static-1.8744",
  "SalesContentIndexUI": "static-3.8917",
  "sanitize": "static-1.4283",
  "sanitize-text": "static-1.7949",
  "self-service-api": "static-1.10045",
  "SharedI18nStrings": "static-1.180",
  "SharedLegalStrings": "static-1.1561",
  "signup-constants": "static-1.18424",
  "signup-ui-lego-core": "static-1.20434",
  "signup-ui-url-generator": "static-2.7858",
  "styled-components": "static-2.85",
  "StyleGuideUI": "static-3.484",
  "superstore": "static-1.4579",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10803",
  "ui-addon-i18n": "static-1.10949",
  "ui-addon-react-router-dom": "static-1.9355",
  "ui-addon-upgrades": "static-9.17674",
  "ui-asset-management-lib": "static-1.10722",
  "ui-images": "static-2.1094",
  "UIComponents": "static-3.8188",
  "usage-tracker": "static-1.7143",
  "usage-tracker-container": "static-1.7133",
  "usage-tracker-core": "static-1.6993",
  "usage-tracker-public": "static-1.6954",
  "viral-links-lib": "static-1.6844",
  "hs-promise-rejection-tracking": "static-1.5387",
  "raven-hubspot": "static-1.6032",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3237",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3024",
  "quartz-webpack": "static-1.2971",
  "ai-components-ui-library": "static-1.8368",
  "amplitude-session-replay-browser": "static-1.55",
  "foundations-assets": "static-1.4645",
  "foundations-theming": "static-1.4220",
  "quartz-auth": "static-1.422",
  "ui-business-units-lib": "static-1.8837",
  "usage-tracker-session-replay": "static-1.4829",
  "foundations-theming-base": "static-1.3205",
  "HeadJS": "static-2.711",
  "framer-motion": "static-1.67",
  "hs-test-utils-bend-plugin": "static-1.2925",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4135",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7733",
  "graphql": "static-1.77",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3425",
  "persist-promise": "static-1.3517",
  "reporting-client-types": "static-1.2387",
  "foundations-components-legacy": "static-1.565",
  "hs-story-utils": "static-1.9236",
  "react-flip-move": "static-1.65",
  "hub-http-shared-msw-handlers": "static-1.9496",
  "hubspotter-http": "static-1.4486",
  "sassPrefix": "static-1.152",
  "conversations-skeleton-state": "static-1.7056",
  "crm-message-bus": "static-1.42394",
  "customer-data-filters-ui-msw-helpers": "static-1.21374",
  "customer-data-objects-ui-components": "static-1.12816",
  "customer-data-reference-ui-components": "static-1.12954",
  "customer-data-ui-utilities": "static-1.9632",
  "framework-builder-read-service-client": "static-1.3841",
  "framework-data-schema-quick-fetch": "static-1.6587",
  "framework-data-schema-resolvers": "static-1.6682",
  "inbound-db-properties-service-client": "static-1.3683",
  "multi-account-reference-resolvers": "static-1.782",
  "onboarding-tours": "static-1.16274",
  "reporting-datasets-permissions-lib": "static-1.13079",
  "ui-addon-teams": "static-1.21256",
  "apollo-stack-hubspot": "static-3.81",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67650",
  "customer-data-properties": "static-1.50824",
  "forms-ai-lib": "static-1.4020",
  "forms-utils-lib": "static-1.12185",
  "foundations-components-test-utils": "static-1.5023",
  "react-dnd-compat": "static-1.4429",
  "react-tinymce": "static-1.54646",
  "tinymce-config": "static-2.53772",
  "ui-gdpr-components": "static-1.10156",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3809",
  "floating-ui": "static-1.51",
  "react-aria": "static-1.61",
  "tanstack-table": "static-1.50",
  "trellis-assets": "static-1.1232",
  "ui-fonts": "static-1.503",
  "dispatcher": "static-1.132",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.796",
  "mobile-manifest-mixins": "static-1.484",
  "module-federation": "static-1.18",
  "quartz-head": "static-1.412",
  "quartz-i18n": "static-1.422",
  "quartz-routing": "static-1.177",
  "quartz-test": "static-1.422",
  "quartz-tracking": "static-1.126",
  "batch-promise": "static-1.1360",
  "external-options-client-types": "static-1.3992",
  "react-colorpicker": "static-2.10018",
  "copilot-toolkit": "static-1.10556",
  "data-quality-ui-library": "static-1.12341",
  "html-to-image": "static-1.49",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40680",
  "reporting-insights-lib": "static-1.1191",
  "reporting-plugins": "static-1.9994",
  "ui-addon-draggable-compat": "static-2.4062",
  "ui-addon-opt": "static-4.8193",
  "ui-shepherd-react": "static-3.9956",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24754",
  "hubspot-apollo-client": "static-1.4690",
  "sales-templates-service-types-lib": "static-1.3999",
  "merchandise-lib": "static-1.259",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5494",
  "salesImages": "static-1.521",
  "ts-schema": "static-1.3912",
  "timezone-utils": "static-2.5053",
  "bender-build-tools": "static-1.2956",
  "chatspot-core": "static-1.20358",
  "chirp-fetch": "static-1.1691",
  "bend-plugin-foundations-theming": "static-1.2703",
  "stylex": "static-1.27",
  "hubspotter-http-shared-msw-handlers": "static-1.9494",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3631",
  "crm-pipelines-api-client-types": "static-1.3972",
  "multi-currency-client-types": "static-1.3525",
  "getting-started-shared-tasks": "static-1.17911",
  "growth-data-modal": "static-1.5167",
  "growth-onboarding-confetti": "static-1.2881",
  "growth-onboarding-next-action-utils": "static-1.1313",
  "navigation-components": "static-1.17297",
  "onboarding-tours-client": "static-1.4488",
  "onboarding-tours-utils": "static-1.340",
  "ui-shepherd-tracker": "static-1.7337",
  "ui-universal-auth": "static-1.8712",
  "user-context": "static-1.4908",
  "cms-field-types": "static-1.4615",
  "content-icons-ui": "static-1.2156",
  "integrations-lib": "static-1.15446",
  "calling-global-api": "static-1.63703",
  "calling-internal-common": "static-1.31103",
  "calling-lifecycle-internal": "static-1.65085",
  "calling-lifecycle-messages": "static-1.57379",
  "commerce-products-lib": "static-1.8885",
  "crm-links": "static-1.6075",
  "file-manager-components": "static-1.22916",
  "google-libphonenumber": "static-1.33",
  "hs-entities": "static-1.487",
  "inbounddb-objects-service-types": "static-1.4057",
  "meetings-icalendar-utils-lib": "static-1.442",
  "object-builder-ui-client": "static-1.48009",
  "pipeline-validation-client-types": "static-1.3794",
  "property-value-citations": "static-1.1438",
  "pulse": "static-1.321",
  "smart-property-lib": "static-1.5948",
  "tiered-pricing": "static-1.843",
  "ui-addon-iframeable": "static-1.8853",
  "final-form": "static-1.65",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19484",
  "tinymce-themes": "static-1.55742",
  "data-token-picker": "static-1.16056",
  "hub-http-contrib": "static-1.2852",
  "interframe": "static-3.4599",
  "tinymce-data": "static-1.39857",
  "tinymce-plugins": "static-1.56886",
  "ui-addon-sales-email": "static-1.5022",
  "magpie-lib": "static-1.5402",
  "magpie-types": "static-1.4862",
  "simple-logging-lib": "static-1.2859",
  "content-assistance-lib": "static-1.7462",
  "dashboard-lib": "static-1.80663",
  "ExportDialog": "static-6.10195",
  "hubspot-prosemirror": "static-1.17632",
  "hubspot-prosemirror-plugins": "static-1.17624",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8500",
  "campaign-roi-lib": "static-1.8302",
  "feedback-loader": "static-1.28871",
  "onboarding-scopes": "static-1.6272",
  "apollo-link-hub-http": "static-2.4458",
  "hubspot-apollo-cache": "static-1.149",
  "growth-monetization-service-types": "static-1.4322",
  "nav-client-types": "static-1.2166",
  "purchase-motions-api": "static-1.5497",
  "trials-service-types": "static-1.3723",
  "growth-onboarding-next-action-components": "static-1.1341",
  "user-context-client": "static-1.4477",
  "idb-keyval": "static-1.39",
  "reactive-lib": "static-1.534",
  "unified-auth-core-lib": "static-1.507",
  "getting-started-shared-tasks-store": "static-1.17029",
  "integrations-error-boundary-lib": "static-1.12861",
  "integrations-tracking-lib": "static-1.5397",
  "native-integrations-shared-strings": "static-1.7597",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10180",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31109",
  "shared-worker-versioning": "static-1.10847",
  "calling-usage-tracker": "static-1.6349",
  "voice-sms-access-library": "static-1.274",
  "customer-data-tracking": "static-1.6691",
  "commerce-permissions": "static-1.567",
  "products-iframe-lib": "static-1.7343",
  "products-ui-components-shared-msw-handlers": "static-1.9878",
  "location-customization-utils-lib": "static-1.8590",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3964",
  "video-components-external": "static-1.10595",
  "video-data-lib": "static-1.34253",
  "directed-graph": "static-1.745",
  "event-emitter": "static-1.756",
  "breeze-intelligence-kit": "static-1.5333",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9579",
  "fsm": "static-1.3540",
  "policy-lib": "static-1.6595",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9642",
  "navigation-messaging": "static-1.6624",
  "FileManagerLib": "static-1.38556",
  "NamespacedHubStyle": "static-2.8904",
  "FileManagerCore": "static-1.38415",
  "codemirror": "static-5.90",
  "layout-dnd-components": "static-1.12049",
  "layout-dnd-utils": "static-1.11024",
  "react-codemirror": "static-1.10435",
  "ui-addon-emoji-picker": "static-1.9697",
  "ui-brand-identity-lib": "static-1.13921",
  "ui-addon-video-player": "static-1.8505",
  "ui-coaching-tips": "static-1.27968",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8377",
  "payment-link-components": "static-1.22966",
  "EmailSignatureEditor": "static-1.23928",
  "eligibility-engine-service-types": "static-1.3004",
  "universal-page-editor-lib": "static-1.2808",
  "calling-orchestration-schema": "static-1.35051",
  "sales-views-client-types": "static-1.4096",
  "crm-record-cards-service-types": "static-1.3460",
  "content-media-composition-data-lib": "static-1.11488",
  "content-media-compositions": "static-2.15495",
  "media-bridge-lib": "static-1.18579",
  "trellis-story-utils": "static-1.4330",
  "storybook-react": "static-1.28",
  "audio-components": "static-1.5625",
  "FileManagerImages": "static-1.36067",
  "video-components": "static-1.12598",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4341",
  "video-embed": "static-1.35087",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67725",
  "layout-data-lib": "static-1.9349",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6392",
  "commerce-tours-lib": "static-1.5733",
  "growth-onboarding-reliability": "static-1.4895",
  "sales-checkout-service-client": "static-1.3477",
  "draft-convert": "static-2.67",
  "draft-extend": "static-3.70",
  "draft-js": "static-5.72",
  "draft-plugins": "static-2.21321",
  "sales-email-signature-service-client": "static-1.3653",
  "hls.js": "static-1.34",
  "social-insights-client-types": "static-1.21373",
  "outpost": "static-1.4013",
  "advanced-menus-core": "static-1.14827",
  "advanced-menus-lib": "static-1.11800",
  "ui-memberships-settings-lib": "static-1.33450",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14826",
  "simple-menus-lib": "static-1.16343"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33994",
  "client-types": "/client-types/static-1.446",
  "documents-lib": "/documents-lib/static-1.33999",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1936",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4841",
  "highcharts": "/highcharts/static-8.99",
  "hs-promise-utils": "/hs-promise-utils/static-1.5402",
  "hs-test-utils": "/hs-test-utils/static-1.7814",
  "hub-http": "/hub-http/static-1.6029",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "HubStyleTokens": "/HubStyleTokens/static-2.11241",
  "I18n": "/I18n/static-7.1572",
  "jasmine-immutable": "/jasmine-immutable/static-1.2827",
  "jasmine-runner": "/jasmine-runner/static-1.6281",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6747",
  "react": "/react/static-7.179",
  "react-dlb": "/react-dlb/static-1.72",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.67",
  "react-rhumb": "/react-rhumb/static-1.16459",
  "reporting-data": "/reporting-data/static-1.66564",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8497",
  "reporting-visualizations": "/reporting-visualizations/static-1.58640",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4574",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4878",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2295",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.734",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38939",
  "customer-data-objects": "/customer-data-objects/static-1.7458",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7886",
  "data-fetching-client": "/data-fetching-client/static-1.9487",
  "enviro": "/enviro/static-4.405",
  "FireAlarmUi": "/FireAlarmUi/static-1.4337",
  "flux-actions": "/flux-actions/static-1.310",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85309",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4538",
  "foundations-components": "/foundations-components/static-1.7540",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyle": "/HubStyle/static-2.11549",
  "icons": "/icons/static-2.623",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6969",
  "metrics-js": "/metrics-js/static-1.9436",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.367",
  "property-description-translator": "/property-description-translator/static-1.3667",
  "property-translator": "/property-translator/static-1.5221",
  "quartz-config": "/quartz-config/static-1.525",
  "quartz-core": "/quartz-core/static-1.5966",
  "quick-fetch": "/quick-fetch/static-1.3743",
  "raven": "/raven/static-3.5725",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5181",
  "react-virtualized": "/react-virtualized/static-2.94",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7969",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7903",
  "report-customization-components": "/report-customization-components/static-1.12529",
  "reporting-enablement": "/reporting-enablement/static-1.22106",
  "reporting-reports": "/reporting-reports/static-1.66242",
  "reporting-snowflake": "/reporting-snowflake/static-1.55182",
  "reporting-ui-components": "/reporting-ui-components/static-2.63835",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4443",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8744",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8917",
  "sanitize": "/sanitize/static-1.4283",
  "sanitize-text": "/sanitize-text/static-1.7949",
  "self-service-api": "/self-service-api/static-1.10045",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1561",
  "signup-constants": "/signup-constants/static-1.18424",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20434",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7858",
  "styled-components": "/styled-components/static-2.85",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "superstore": "/superstore/static-1.4579",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10803",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10949",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9355",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17674",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10722",
  "ui-images": "/ui-images/static-2.1094",
  "UIComponents": "/UIComponents/static-3.8188",
  "usage-tracker": "/usage-tracker/static-1.7143",
  "usage-tracker-container": "/usage-tracker-container/static-1.7133",
  "usage-tracker-core": "/usage-tracker-core/static-1.6993",
  "usage-tracker-public": "/usage-tracker-public/static-1.6954",
  "viral-links-lib": "/viral-links-lib/static-1.6844",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
  "raven-hubspot": "/raven-hubspot/static-1.6032",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3237",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3024",
  "quartz-webpack": "/quartz-webpack/static-1.2971",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8368",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.55",
  "foundations-assets": "/foundations-assets/static-1.4645",
  "foundations-theming": "/foundations-theming/static-1.4220",
  "quartz-auth": "/quartz-auth/static-1.422",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8837",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4829",
  "foundations-theming-base": "/foundations-theming-base/static-1.3205",
  "HeadJS": "/HeadJS/static-2.711",
  "framer-motion": "/framer-motion/static-1.67",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2925",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4135",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7733",
  "graphql": "/graphql/static-1.77",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3425",
  "persist-promise": "/persist-promise/static-1.3517",
  "reporting-client-types": "/reporting-client-types/static-1.2387",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.565",
  "hs-story-utils": "/hs-story-utils/static-1.9236",
  "react-flip-move": "/react-flip-move/static-1.65",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9496",
  "hubspotter-http": "/hubspotter-http/static-1.4486",
  "sassPrefix": "/sassPrefix/static-1.152",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7056",
  "crm-message-bus": "/crm-message-bus/static-1.42394",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21374",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12816",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12954",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9632",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3841",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6587",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6682",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3683",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.782",
  "onboarding-tours": "/onboarding-tours/static-1.16274",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13079",
  "ui-addon-teams": "/ui-addon-teams/static-1.21256",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.81",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67650",
  "customer-data-properties": "/customer-data-properties/static-1.50824",
  "forms-ai-lib": "/forms-ai-lib/static-1.4020",
  "forms-utils-lib": "/forms-utils-lib/static-1.12185",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5023",
  "react-dnd-compat": "/react-dnd-compat/static-1.4429",
  "react-tinymce": "/react-tinymce/static-1.54646",
  "tinymce-config": "/tinymce-config/static-2.53772",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10156",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3809",
  "floating-ui": "/floating-ui/static-1.51",
  "react-aria": "/react-aria/static-1.61",
  "tanstack-table": "/tanstack-table/static-1.50",
  "trellis-assets": "/trellis-assets/static-1.1232",
  "ui-fonts": "/ui-fonts/static-1.503",
  "dispatcher": "/dispatcher/static-1.132",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.796",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.484",
  "module-federation": "/module-federation/static-1.18",
  "quartz-head": "/quartz-head/static-1.412",
  "quartz-i18n": "/quartz-i18n/static-1.422",
  "quartz-routing": "/quartz-routing/static-1.177",
  "quartz-test": "/quartz-test/static-1.422",
  "quartz-tracking": "/quartz-tracking/static-1.126",
  "batch-promise": "/batch-promise/static-1.1360",
  "external-options-client-types": "/external-options-client-types/static-1.3992",
  "react-colorpicker": "/react-colorpicker/static-2.10018",
  "copilot-toolkit": "/copilot-toolkit/static-1.10556",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12341",
  "html-to-image": "/html-to-image/static-1.49",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40680",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1191",
  "reporting-plugins": "/reporting-plugins/static-1.9994",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4062",
  "ui-addon-opt": "/ui-addon-opt/static-4.8193",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9956",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24754",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4690",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3999",
  "merchandise-lib": "/merchandise-lib/static-1.259",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5494",
  "salesImages": "/salesImages/static-1.521",
  "ts-schema": "/ts-schema/static-1.3912",
  "timezone-utils": "/timezone-utils/static-2.5053",
  "bender-build-tools": "/bender-build-tools/static-1.2956",
  "chatspot-core": "/chatspot-core/static-1.20358",
  "chirp-fetch": "/chirp-fetch/static-1.1691",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2703",
  "stylex": "/stylex/static-1.27",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9494",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3631",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3972",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3525",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17911",
  "growth-data-modal": "/growth-data-modal/static-1.5167",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2881",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1313",
  "navigation-components": "/navigation-components/static-1.17297",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4488",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.340",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7337",
  "ui-universal-auth": "/ui-universal-auth/static-1.8712",
  "user-context": "/user-context/static-1.4908",
  "cms-field-types": "/cms-field-types/static-1.4615",
  "content-icons-ui": "/content-icons-ui/static-1.2156",
  "integrations-lib": "/integrations-lib/static-1.15446",
  "calling-global-api": "/calling-global-api/static-1.63703",
  "calling-internal-common": "/calling-internal-common/static-1.31103",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65085",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57379",
  "commerce-products-lib": "/commerce-products-lib/static-1.8885",
  "crm-links": "/crm-links/static-1.6075",
  "file-manager-components": "/file-manager-components/static-1.22916",
  "google-libphonenumber": "/google-libphonenumber/static-1.33",
  "hs-entities": "/hs-entities/static-1.487",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4057",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.442",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48009",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3794",
  "property-value-citations": "/property-value-citations/static-1.1438",
  "pulse": "/pulse/static-1.321",
  "smart-property-lib": "/smart-property-lib/static-1.5948",
  "tiered-pricing": "/tiered-pricing/static-1.843",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8853",
  "final-form": "/final-form/static-1.65",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19484",
  "tinymce-themes": "/tinymce-themes/static-1.55742",
  "data-token-picker": "/data-token-picker/static-1.16056",
  "hub-http-contrib": "/hub-http-contrib/static-1.2852",
  "interframe": "/interframe/static-3.4599",
  "tinymce-data": "/tinymce-data/static-1.39857",
  "tinymce-plugins": "/tinymce-plugins/static-1.56886",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5022",
  "magpie-lib": "/magpie-lib/static-1.5402",
  "magpie-types": "/magpie-types/static-1.4862",
  "simple-logging-lib": "/simple-logging-lib/static-1.2859",
  "content-assistance-lib": "/content-assistance-lib/static-1.7462",
  "dashboard-lib": "/dashboard-lib/static-1.80663",
  "ExportDialog": "/ExportDialog/static-6.10195",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17632",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17624",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8500",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8302",
  "feedback-loader": "/feedback-loader/static-1.28871",
  "onboarding-scopes": "/onboarding-scopes/static-1.6272",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4458",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.149",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4322",
  "nav-client-types": "/nav-client-types/static-1.2166",
  "purchase-motions-api": "/purchase-motions-api/static-1.5497",
  "trials-service-types": "/trials-service-types/static-1.3723",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1341",
  "user-context-client": "/user-context-client/static-1.4477",
  "idb-keyval": "/idb-keyval/static-1.39",
  "reactive-lib": "/reactive-lib/static-1.534",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.507",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17029",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12861",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5397",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7597",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10180",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31109",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10847",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6349",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.274",
  "customer-data-tracking": "/customer-data-tracking/static-1.6691",
  "commerce-permissions": "/commerce-permissions/static-1.567",
  "products-iframe-lib": "/products-iframe-lib/static-1.7343",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9878",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8590",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3964",
  "video-components-external": "/video-components-external/static-1.10595",
  "video-data-lib": "/video-data-lib/static-1.34253",
  "directed-graph": "/directed-graph/static-1.745",
  "event-emitter": "/event-emitter/static-1.756",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5333",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9579",
  "fsm": "/fsm/static-1.3540",
  "policy-lib": "/policy-lib/static-1.6595",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9642",
  "navigation-messaging": "/navigation-messaging/static-1.6624",
  "FileManagerLib": "/FileManagerLib/static-1.38556",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8904",
  "FileManagerCore": "/FileManagerCore/static-1.38415",
  "codemirror": "/codemirror/static-5.90",
  "layout-dnd-components": "/layout-dnd-components/static-1.12049",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11024",
  "react-codemirror": "/react-codemirror/static-1.10435",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9697",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13921",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8505",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27968",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8377",
  "payment-link-components": "/payment-link-components/static-1.22966",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23928",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3004",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2808",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35051",
  "sales-views-client-types": "/sales-views-client-types/static-1.4096",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3460",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11488",
  "content-media-compositions": "/content-media-compositions/static-2.15495",
  "media-bridge-lib": "/media-bridge-lib/static-1.18579",
  "trellis-story-utils": "/trellis-story-utils/static-1.4330",
  "storybook-react": "/storybook-react/static-1.28",
  "audio-components": "/audio-components/static-1.5625",
  "FileManagerImages": "/FileManagerImages/static-1.36067",
  "video-components": "/video-components/static-1.12598",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4341",
  "video-embed": "/video-embed/static-1.35087",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67725",
  "layout-data-lib": "/layout-data-lib/static-1.9349",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6392",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5733",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4895",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3477",
  "draft-convert": "/draft-convert/static-2.67",
  "draft-extend": "/draft-extend/static-3.70",
  "draft-js": "/draft-js/static-5.72",
  "draft-plugins": "/draft-plugins/static-2.21321",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3653",
  "hls.js": "/hls.js/static-1.34",
  "social-insights-client-types": "/social-insights-client-types/static-1.21373",
  "outpost": "/outpost/static-1.4013",
  "advanced-menus-core": "/advanced-menus-core/static-1.14827",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11800",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33450",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14826",
  "simple-menus-lib": "/simple-menus-lib/static-1.16343"
}
};
